export function getAffiliationFromHotel(hotel: any): string {
  const explicit = hotel?.relationships?.field_hotel_ownership?.name;
  if (explicit) return explicit;

  try {
    const cmsOwnership = hotel?.relationships?.field_hotel_ownership;
    console.warn("[DL][Affiliation] field_hotel_ownership not in CMS", {
      hotel: hotel,
    });
  } catch (e) {
    console.error(e);
  }

  return "";
}

export default getAffiliationFromHotel;
